import { ClearFormatting } from 'almanac-ui/icons/16'
import { useClearFormattingButton } from 'common/Prose/Toolbar/hooks/useClearFormattingButton'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'

export const ClearFormattingInlineFormatButton = observer(function ClearFormattingInlineFormatButton({
  view,
}: {
  view: EditorView
}) {
  const clearFormatting = useClearFormattingButton(view)

  return (
    <InlineFormatButton data-testid="Clear formatting" label="Clear formatting" onClick={clearFormatting}>
      <ClearFormatting />
    </InlineFormatButton>
  )
})
